import { kpiData } from '../../../mocks/dashboard';

function MiniSparkline({ data, color }: { data: number[]; color: string }) {
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const w = 80;
  const h = 32;
  const points = data.map((v, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((v - min) / range) * h;
    return `${x},${y}`;
  });
  const polyline = points.join(' ');
  const firstPoint = points[0].split(',');
  const lastPoint = points[points.length - 1].split(',');
  const areaPoints = `${firstPoint[0]},${h} ${polyline} ${lastPoint[0]},${h}`;

  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} fill="none">
      <defs>
        <linearGradient id={`sg-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.3" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={areaPoints} fill={`url(#sg-${color.replace('#', '')})`} />
      <polyline points={polyline} stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}

export default function KPICards() {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-3 gap-5">
      {kpiData.map(item => (
        <div key={item.id} className="bg-white rounded-xl2 shadow-card p-6 flex flex-col gap-3 hover:shadow-hover transition-shadow duration-300">
          <div className="flex items-start justify-between">
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: `linear-gradient(135deg, ${item.color}20, ${item.color}35)` }}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${item.icon} text-[20px]`} style={{ color: item.color }} />
              </div>
            </div>
            <div className={`flex items-center gap-1 text-[12px] font-medium px-2 py-0.5 rounded-full
              ${item.change >= 0 ? 'text-green-600 bg-green-50' : 'text-red-500 bg-red-50'}
            `}>
              <div className="w-3 h-3 flex items-center justify-center">
                <i className={item.change >= 0 ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
              </div>
              {Math.abs(item.change)}{item.isPercent ? 'p' : '%'}
            </div>
          </div>
          <div>
            <p className="text-[28px] font-bold text-charcoal-600 leading-tight">
              {item.isPercent ? `${item.value}%` : item.value.toLocaleString('tr-TR')}
            </p>
            <p className="text-[13px] text-charcoal-300 mt-0.5">{item.label}</p>
          </div>
          <div className="mt-auto">
            <MiniSparkline data={item.trend} color={item.color} />
          </div>
        </div>
      ))}
    </div>
  );
}
